// import { useMediaQuery } from "@mui/material";
import { useAuth } from '../../../hooks/useAuth';
import { useLocation } from 'react-router-dom';

export default function Navigation({ menu, orientation }) {
  //   const isMobile = useMediaQuery("(max-width: 600px)");
  const { user, logout } = useAuth();
  const location = useLocation();

  const navigationItems = [
    { path: '/', title: 'Home' },
    { path: '/events', title: 'Events' },
    { path: '/sessions', title: 'Sessions' },
  ];

  return (
    <nav className="flex-1">
      <ul className={`flex gap-2 items-center ${orientation === 'vertical' ? 'flex-col' : 'flex-row'}`}>
        {user &&
          navigationItems.map((item, index) => {
            const isActive = location.pathname === item.path;
            return (
              <li key={index}>
                <a 
                  href={item.path}
                  className={`px-4 py-2 rounded-lg font-medium text-sm transition-all ${
                    isActive 
                      ? 'bg-blue-600 text-white shadow-md' 
                      : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50'
                  }`}
                >
                  {item.title}
                </a>
              </li>
            );
          })}

        {user && (
          <li className="ml-auto">
            <a
              href="/upload"
              className="inline-flex items-center px-5 py-2.5 rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:from-blue-700 hover:to-indigo-700 shadow-lg hover:shadow-xl transition-all duration-200 font-semibold text-sm border border-blue-700/50"
            >
              Upload
            </a>
          </li>
        )}

        {user && (
          <li>
            <button 
              onClick={() => logout()}
              className="px-5 py-2.5 rounded-lg bg-red-500 text-white hover:bg-red-600 hover:shadow-lg transition-all duration-200 font-semibold text-sm shadow-md"
            >
              Logout
            </button>
          </li>
        )}

        {user ? (
          ''
        ) : (
          <li>
            <a 
              href="/"
              className="px-4 py-2 rounded-lg text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-all font-medium text-sm"
            >
              Login
            </a>
          </li>
        )}
      </ul>
    </nav>
  );
}